<template>
  <v-form v-model="valid" ref="mainForm">
    <adresse-personnelle :carteAffaire="sas.adressePersonnelle" two-columns></adresse-personnelle>

    <opq-date-picker
      code="date-de-naissance"
      is-birthdate
      v-model="permisPsychologue.dateDeNaissance"
      :live="liveSasPermisPsychologue(2112)"
    ></opq-date-picker>
    <opq-catalogue
      code="citoyennete-ou-residence"
      v-model="permisPsychologue.citoyenneteOuResidence"
      :live="liveSasPermisPsychologue(2114)"
      order-by="id"
    >
    </opq-catalogue>

    <opq-file code="preuve-admissibilite" :live="liveSasPermisPsychologue(2116)" :file="permisPsychologue.preuveDAdmissibilite"></opq-file>

    <opq-catalogue
      :opq-if="typeAdmissionEstPermisSurPermis"
      code="permis-psychologue-province-canadienne"
      :optional="!typeAdmissionEstPermisSurPermis"
      v-model="permisPsychologue.permisProvinceCanadienne"
      :live="liveSasPermisPsychologue(2102)"
    >
    </opq-catalogue>
    <opq-catalogue
      :opq-if="estOui(permisPsychologue.permisProvinceCanadienne)"
      code="province-permis-psychologue"
      v-model="permisPsychologue.precisezLaProvince"
      :live="liveSasPermisPsychologue(2103)"
      parent="QR1EpL3FU6VRDYAQMz1v4cfCd5wR1EpL1R1EpL1"
    >
    </opq-catalogue>
    <opq-text-field
      :opq-if="estOui(permisPsychologue.permisProvinceCanadienne)"
      code="numero-de-permis-psy-province-canadienne"
      v-model="permisPsychologue.precisezLeNumeroDePermis"
      :live="liveSasPermisPsychologue(2104)"
    ></opq-text-field>

    <opq-catalogue code="permis-autre-profession" v-model="permisPsychologue.permisAutreProfession" :live="liveSasPermisPsychologue(2105)">
    </opq-catalogue>
    <opq-text-field
      :opq-if="estOui(permisPsychologue.permisAutreProfession)"
      code="profession"
      v-model="permisPsychologue.precisezLaProfession"
      :live="liveSasPermisPsychologue(2106)"
    ></opq-text-field>
    <opq-text-field
      :opq-if="estOui(permisPsychologue.permisAutreProfession)"
      code="pays-province-autre-profession"
      v-model="permisPsychologue.precisezLePaysEtLaProvince"
      :live="liveSasPermisPsychologue(2107)"
    ></opq-text-field>
    <opq-text-field
      :opq-if="estOui(permisPsychologue.permisAutreProfession)"
      code="numero-permis-autre-profession"
      v-model="permisPsychologue.precisezLeNumeroDePermis2"
      :live="liveSasPermisPsychologue(2108)"
    ></opq-text-field>
  </v-form>
</template>

<script>
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import FormSimple from "@/mixins/FormSimple"
import AdressePersonnelle from "@/components/FormParts/AdressePersonnelle"
export default {
  mixins: [CataloguesHelper, FormSimple],
  components: { AdressePersonnelle },
  props: {
    sas: { type: Object }
  },

  methods: {
    liveSasPermisPsychologue(cle) {
      return { endpoint: "sas-permis-psychologue", cle: cle, fileId: this.permisPsychologue.id }
    }
  },

  computed: {
    permisPsychologue() {
      return this.sas.permisPsychologue
    },
    citoyenneteOuResidenceEstPerm() {
      return this.getCatalogueCodeById(221, this.permisPsychologue.citoyenneteOuResidence) == "PERM"
    },
    typeAdmissionEstPermisSurPermis() {
      return this.getCatalogueCodeById(2117, this.permisPsychologue.typeDAdmission) == "PSP"
    }
  }
}
</script>

<style>
</style>